import { initSwiper } from '@resources/js/components/initSwiper';
import inViewport from '@resources/js/helpers/inViewport';
import hasHover from '@resources/js/helpers/hasHover';
import addSlidesToSlider from '@resources/js/helpers/addSlidesToSlider';
const isHoverDevice = hasHover();
const wrapElements = document.querySelectorAll('.js-attraction-block-photo-wrap');
wrapElements.forEach(wrapElement => {
    const photoSliderElement = wrapElement.querySelector('.js-photo-slider');
    if (!photoSliderElement)
        return;
    inViewport(wrapElement, () => {
        initSwiper(photoSliderElement, {
            loop: false,
            spaceBetween: 4,
            allowTouchMove: !isHoverDevice,
            navigation: {
                nextEl: wrapElement.querySelector('.js-photo-next-btn'),
                prevEl: wrapElement.querySelector('.js-photo-prev-btn'),
            },
            pagination: {
                el: wrapElement.querySelector('.js-photo-pagination'),
                type: 'fraction',
                renderFraction: (currentClass) => `<span class="${currentClass}"></span>/${photoSliderElement.dataset.photoTotal}`,
            },
        });
        photoSliderElement.swiper.once('slideChange', () => addSlidesToSlider(photoSliderElement));
    });
});
